import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { IBankingInfo } from '../../../common/interface/iBankingInfo';
import { IReceivedPaymentInfo } from '../../../common/interface/iReceivedPaymentInfo';
import { ISendPaymentInfo } from '../../../common/interface/iSendPaymentInfo';
import { PaymentService } from '../../../common/service/payment.service';
import { WindowService } from '../../../common/service/window.service';
import { ModalService } from '../../../common/service/modal.service';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ModalRouteService } from '../../../common/service/modal-route.service';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Product } from '../../../../../../js/static/Product';
import { amorphicStatic } from '@haventech/amorphic';

@Component({
  selector: 'payment-form-component',
  templateUrl: './paymentForm.html',
  providers: [PaymentService, WindowService, ModalService],
})
export class PaymentFormComponent implements OnInit {
  @Input() dismiss;
  @Input() policyType: string;
  public receivedPaymentInfo: IReceivedPaymentInfo;
  public updatePaymentPayload: ISendPaymentInfo;
  public policyNumber: string = '';
  public isSimplifiedIssue: boolean = false;
  public selectedPaymentType: string = 'BankAccount';
  public policyAdminDown: boolean = false;
  public useSecondary: boolean = false;
  public termsPDF: string;
  public widgetType: string;
  public isPaymentTypeSwitchingEnabled: boolean = false;
  public areCreditCardsEnabled: boolean = false;
  public isTerm2: boolean = false;
  constructor(
    private paymentService: PaymentService,
    private windowService: WindowService,
    public modalService: ModalService,
    private modalRouteService: ModalRouteService,
    private router: Router,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private amorphicService: AmorphicService
  ) {
    this.widgetType = this.paymentService.getChannelName();

    switch (this.widgetType) {
      case Product.channels.CAS.name:
      case Product.channels.MMOPM.name:
      case Product.channels.MMTRAD.name:
        this.termsPDF = 'premium_payment_services_terms_conditions_cpath.pdf';
        break;
      case Product.channels.MMDirect.name:
        this.termsPDF = 'premium_payment_services_terms_conditions_mmdirect.pdf';
        break;
      default:
        throw Error(`No Terms and Conditions found for channel ${this.paymentService.getChannelName()}`);
    }
  }

  ngOnInit() {
    const application = this.amorphicService.controller.customer.application;
    if (this.policyType && this.policyType === 'Term' && application.isJointApp()) {
      this.policyNumber = application.secondaryPolicy.policyNumber;
      this.useSecondary = true;
    } else {
      this.useSecondary = false;
      this.policyNumber = application.primaryPolicy.policyNumber;
    }
    if (this.policyNumber) {
      this.paymentService.getPaymentInfo(this.useSecondary).then((paymentInfo) => {
        this.receivedPaymentInfo = paymentInfo;

        if (!paymentInfo || paymentInfo.policyAdminDown || this.paymentService.policyAdminDown === true) {
          this.policyAdminDown = true;
          this.cdRef.detectChanges();
          return;
        }

        this.receivedPaymentInfo = paymentInfo;
        if (this.receivedPaymentInfo.company === 'C.M.') {
          this.termsPDF = 'premium_payment_services_terms_conditions.pdf';
        }

        //first time instantiation need policy number.
        this.updatePaymentPayload = this.paymentService.getSendPaymentInfo(this.policyNumber);
        this.cdRef.detectChanges();
      });
    } else {
      throw new Error('Policy Number is needed to init payment component.');
    }
  }

  handleFinish(wasUpdated: boolean): void {
    if (wasUpdated) {
      this.modalRouteService.changeRoute('complete');
      document.querySelector('body').classList.remove('modal-container__fullpage');
    } else {
      this.checkCancel();
    }
  }

  setSelectedPaymentType(type: string): void {
    this.selectedPaymentType = type;
  }

  isActive(type: string): string {
    if (type === this.selectedPaymentType) {
      return 'blue-info';
    }
    return '';
  }

  cancelForm() {
    const ctrl = this.windowService.nativeWindow.controller;
    if (
      ctrl &&
      ctrl.cancelFnForPaymentInfoWidget &&
      typeof this.windowService.nativeWindow.controller.cancelFnForPaymentInfoWidget === 'function'
    ) {
      this.windowService.nativeWindow.controller.cancelFnForPaymentInfoWidget();
    } else {
      this.router.navigate(['complete']);
    }
    document.querySelector('body').classList.remove('modal-container__fullpage');
  }

  checkCancel(): void {
    if (this.receivedPaymentInfo === undefined || this.receivedPaymentInfo.policyAdminDown) {
      this.paymentService.reset();
      this.dismiss();
      document.querySelector('body').classList.remove('modal-container__fullpage');
    } else {
      this.modalService.showModal = true;
    }
  }
}
